<script>
    import validate   from 'validate.js'
    import * as api   from '../../shared/api.js'
    import FieldError from '../../shared/FieldError.svelte'

    export let item
    export let domain

    let working         = false
    let error           = false
    let values          = {}
    let formConstraints = {}
    let scope           = null
    let simulation      = null
    
    item.constraints.forEach(constraint => {
        if(constraint.required) {
            formConstraints[constraint.key] = { presence: { allowEmpty: false, message: "campo obrigatório" } }
        }
    })

    function simulate() {
        working = true
        return api
            .post("/inventory/simulate", { profile: item.id, domain: item.domain, scope, keys: values })
            .then(api.toTextIf200)
            .then(text => {
                working = false
                error   = false
                simulation = text
            })
            .catch(err => {
                working = false
                error   = true
                console.log(err)
            })        
    }

    $: errors = validate(values, formConstraints, { fullMessages: false }) || {}
    $: hasErrors = Object.keys(errors).length > 0

</script>
<div class="top">
    <h3 class="ui header">Simulação de Pedido</h3>
    <!-- <pre>
        {JSON.stringify(item.constraints)}
    </pre> -->
    {#if item.constraints.length > 0}
        <div class="ui basic segment toggles">
            <div class="ui toggle checkbox">
                <input type="radio" value="SAR" bind:group={scope}>
                <label>Acesso</label>
            </div>
            <div class="ui toggle checkbox">
                <input type="radio" value="DDR" bind:group={scope}>
                <label>Remoção</label>
            </div>
            <div class="ui toggle checkbox">
                <input type="radio" value="RET" bind:group={scope}>
                <label>Retificação</label>
            </div>
        </div>
        <div class="ui basic segment">
            <form class="ui equal width big form">
                {#each item.constraints as constraint}
                    <div class="field"
                        class:error={errors[constraint.key]}>
                        <label>{constraint.description}</label>
                        <input  bind:value={values[constraint.key]}>
                        <FieldError style="label" property={errors[constraint.key]}/>
                    </div>
                {/each}
            </form>
        </div>
        <div class="ui right aligned basic segment">
            <button class="ui button" class:disabled={hasErrors || !scope} on:click={simulate}>Simular</button>
        </div>
    {:else}
        <div class="ui big message">
            Não existem perguntas cadastrados ainda
        </div>
    {/if}
    {#if simulation}
        <pre>{simulation}</pre>
    {/if}
</div>
<style>
    .top {
        margin: 2em 1em;
    }
    .toggles {
        display: flex;
        flex-direction: column;
        margin: 1em;
    }
    .toggles .checkbox {
        margin: 1em 0;
    }
</style>

